import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex flex-wrap gap-3" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "space-y-6 rounded-lg bg-white p-4 shadow sm:p-6" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "min-w-0 flex-1 space-y-1" }
const _hoisted_8 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_9 = { class: "truncate text-sm font-semibold text-gray-900" }
const _hoisted_10 = { class: "flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_14 = ["datetime"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiSettingsRow = _resolveComponent("UiSettingsRow")!
  const _component_UiBadge = _resolveComponent("UiBadge")!
  const _component_UiSettingsSection = _resolveComponent("UiSettingsSection")!
  const _component_UiPagination = _resolveComponent("UiPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_UiButton, {
        variant: "white",
        "text-variant": "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push({ name: 'Integration' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($setup.t('whatsappMeta.list.back')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        ($setup.attendanceUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "text-primary flex items-center justify-center rounded bg-white px-3 py-2 text-sm font-medium shadow ring-1 ring-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50",
              href: $setup.attendanceUrl,
              target: "_blank",
              rel: "noopener noreferrer"
            }, [
              _createTextVNode(_toDisplayString($setup.t('whatsappMeta.list.openAttendance')) + " ", 1 /* TEXT */),
              _createVNode($setup["ExternalLinkIcon"], {
                class: "ml-2 h-4 w-4",
                "aria-hidden": "true"
              })
            ], 8 /* PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_UiButton, {
          variant: "primary",
          "text-variant": "white",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push({ name: 'ConnectWhatsAppMeta' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.t('whatsappMeta.list.connect')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode($setup["WhatsAppMetaHeader"], {
        title: $setup.t('whatsappMeta.list.title'),
        subtitle: $setup.t('whatsappMeta.list.subtitle'),
        summary: $setup.t('whatsappMeta.list.accountCount', $setup.wabas.length)
      }, null, 8 /* PROPS */, ["title", "subtitle", "summary"]),
      ($setup.wabas.length && $setup.policy)
        ? (_openBlock(), _createBlock($setup["CompanyPhoneQuotaSummary"], {
            key: 0,
            used: $setup.policy.used,
            limit: $setup.policy.limit,
            full: $setup.policy.full
          }, null, 8 /* PROPS */, ["used", "limit", "full"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_UiSettingsSection, {
        title: $setup.t('whatsappMeta.list.accounts')
      }, {
        default: _withCtx(() => [
          ($setup.wabas.length === 0)
            ? (_openBlock(), _createBlock(_component_UiSettingsRow, {
                key: 0,
                title: $setup.t('whatsappMeta.list.emptyTitle'),
                description: $setup.t('whatsappMeta.list.empty')
              }, null, 8 /* PROPS */, ["title", "description"]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedWabas, (waba) => {
            return (_openBlock(), _createElementBlock("button", {
              key: waba.wabaId,
              type: "button",
              class: "focus-visible:ring-primary flex min-h-[52px] w-full items-center gap-3 p-4 text-left hover:bg-gray-50/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset",
              onClick: ($event: any) => ($setup.openWaba(waba.wabaId))
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(waba.displayName || waba.wabaId), 1 /* TEXT */),
                  _createVNode(_component_UiBadge, {
                    variant: $setup.WhatsAppWabaStatusColorMap[$setup.wabaStatus(waba)],
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t(`whatsappMeta.list.status.${$setup.wabaStatus(waba)}`)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["variant"])
                ]),
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode($setup["PhoneIcon"], {
                      class: "mr-1 h-4 w-4 flex-none text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString($setup.t(
                                        'whatsappMeta.list.operatingPhoneNumbers',
                                        $setup.operatingPhoneCount(waba),
                                    )), 1 /* TEXT */)
                  ]),
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode($setup["UsersIcon"], {
                      class: "mr-1 h-4 w-4 flex-none text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString(waba.createdByUser?.name || $setup.t('whatsappMeta.list.unknownUser')), 1 /* TEXT */)
                  ]),
                  (waba.createdAt)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                        _createVNode($setup["CalendarIcon"], {
                          class: "mr-1 h-4 w-4 flex-none text-gray-400",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("time", {
                          datetime: waba.createdAt
                        }, _toDisplayString($setup.formatDateAsString(waba.createdAt, 'LL')), 9 /* TEXT, PROPS */, _hoisted_14)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createVNode($setup["ChevronRightIcon"], {
                class: "h-5 w-5 flex-none text-gray-400",
                "aria-hidden": "true"
              })
            ], 8 /* PROPS */, _hoisted_6))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title"]),
      ($setup.wabas.length)
        ? (_openBlock(), _createBlock(_component_UiPagination, {
            key: 1,
            modelValue: $setup.currentPage,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.currentPage) = $event)),
            count: $setup.wabas.length,
            "per-page": $setup.perPage
          }, null, 8 /* PROPS */, ["modelValue", "count"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}